import client from "../libs/HttpClient";

class ProductServices {
  static productList(request) {
    
    const page_no = request.queryKey[1];
    return client.get(`/product?page=${page_no}`, request);
  }
  static addProduct(request) {
    return client.post(`/add-product`, request, {});
  }
  static updateProduct(request) {
    return client.post(`/edit-product`, request, {});
  }
  static viewProduct(params) {
    return client.get(`get-product`, { params });
  }
  static deleteProduct(params) {
    return client.delete(`delete-product`, { params });
  }
  static updateStatusProduct(request) {
    return client.post(`/product-status`, request);
  }
}

export { ProductServices };
